import React from "react";
import "./index.scss";
const TitleBlock = ({ label }) => {
	return (
		<>
			<div className="title-blc d-flex align-items-center">
				<label>{label}</label>
			</div>
		</>
	);

}

export default TitleBlock;